import { q } from "bobjoll/ts/library/gr/dom.q";
import { qq } from 'bobjoll/ts/library/dom';

export default class Countdown {
    private static readonly outer: Function = require('Project/ts/views/partial/countdown.hbs');
    private static readonly inner: Function = require('Project/ts/views/partial/countdown-inner.hbs');

    private element: HTMLElement;
    private settings: Settings;
    private interval: any;

    constructor(settings: Settings) {
        this.settings = {
            language: {
                Days: 'Days',
                Hours: 'Hours',
                Minutes: 'Minutes',
                Seconds: 'Minutes',
            },
            ...settings
        };

        if (this.settings.container.classList.contains('countdown')) {
            this.element = this.settings.container;
        } else {
            this.settings.container.insertAdjacentHTML('beforeend', Countdown.outer());

            this.element = q('.countdown', this.settings.container) || document.createElement('div');
        }

        this.setup();
    }

    private static normalize(number: number) {
        if (number < 10) {
            return '0' + number;
        }

        return number;
    }

    private static count(dateEnd: Date) {
        const _distance = dateEnd.getTime() - new Date().getTime();
        const _second = 1000;
        const _minute = _second * 60;
        const _hour = _minute * 60;
        const _day = _hour * 24;

        let date: {
            Days?: number | string;
            Hours?: number | string;
            Minutes?: number | string;
            Seconds?: number | string;
        } = {};
        let days = Countdown.normalize(Math.floor(_distance / _day));

        if (days > 0) {
            date.Days = days;
        }

        date.Hours = Countdown.normalize(Math.floor((_distance % _day) / _hour));
        date.Minutes = Countdown.normalize(Math.floor((_distance % _hour) / _minute));
        date.Seconds = Countdown.normalize(Math.floor((_distance % _minute) / _second));

        return date;
    }

    private setup() {
        this.element.innerHTML = Countdown.inner({
            date: Countdown.count(this.settings.dateEnd),
            language: this.settings.language
        });

        this.interval = setInterval(() => {
            this.element.innerHTML = Countdown.inner({
                date: Countdown.count(this.settings.dateEnd),
                language: this.settings.language
            });

            if (new Date().getTime() > this.settings.dateEnd.getTime()) {
                clearInterval(this.interval);

                this.element.innerHTML = '';

                qq('.freebies__download')
                    .forEach(buttonElement => {
                        buttonElement.classList.add('disabled');
                        
                        qq('span', buttonElement)
                            .forEach(spanElement => spanElement.innerText = this.element.dataset.dateFinished || 'Finished');
                    });
            }
        }, 1000);
    }
}

interface Settings {
    container: HTMLElement;
    dateEnd: Date;
    language?: {
        Days: string;
        Hours: string;
        Minutes: string;
        Seconds: string;
    }
}